<template>
    <div style="height: 100%">
        <el-header class="navbg">
            <div class="contBox">
                <hq-nav></hq-nav>
            </div>
        </el-header>

        <el-main class="mainBox" style="padding-top: 0">
            <div class="contBox">
                <p class="indexBt">MANET介绍</p>
                <el-row :gutter="60">
                    <el-col :span="4">
                        <div class="navBox">
                            <ul class="navMenu" id="navMenu">
                                <li
                                   v-for="(d,index) in data.listData"
                                   :key="index"
                                   :class="{ clickLi:cur == d.name }"
                                   @click="liSwitch(d.name)">
                                    <a :href="'#'+d.name"> {{ d.name }} </a>
                                </li>
                            </ul>
                        </div>
                    </el-col>

                    <el-col :span="20" class="textCont" :offset="4">
                        <div
                           class="manet"
                           :id="d.name"
                           v-for="(d,index) in data.listData"
                           :key="index"
                           :class="{'textMainMag':d.name == '载波聚合'}"
                        >
                            <h1><span>{{ d.btText[0] }}</span>{{ d.btText[1] }}</h1>
                            <el-divider class="fg"></el-divider>
                            <p class="text" v-for="(t,index) in d.child" :key="index" >
                                <el-row :gutter="0" v-if="d.name == 'MIMO' && index == 0" class="COFDMIcon">
                                    <el-col :span="24">
                                        <el-row type="flex"  justify="space-between">
                                            <el-col :span="6">
                                                <img src="../assets/images/mimo_3.jpg" alt="">
                                            </el-col>
                                        </el-row>
                                        <el-row type="flex" justify="space-between">
                                            <el-col :span="6">
                                                <img src="../assets/images/mimo_2.jpg" alt="">
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                                <el-row type="flex" v-if="d.name == '跳频' && index == 0" class="COFDMIcon" justify="space-between">
                                    <el-col :span="24">
                                        <img src="../assets/images/tp.jpg" alt="">
                                    </el-col>
                                </el-row>
                                {{ t }}
                                <el-row type="flex" v-if="d.name == 'MANET' && index == 2" class="ManetIcon" justify="space-between">
                                    <el-col :span="4">
                                        <img src="../assets/images/manet_1.jpg" alt="">
                                    </el-col>
                                    <el-col :span="4">
                                        <img src="../assets/images/manet_2.jpg" alt="">
                                    </el-col>
                                    <el-col :span="4">
                                        <img src="../assets/images/manet_3.jpg" alt="">
                                    </el-col>
                                    <el-col :span="4">
                                        <img src="../assets/images/manet_4.jpg" alt="">
                                    </el-col>
                                    <el-col :span="4">
                                        <img src="../assets/images/manet_5.jpg" alt="">
                                    </el-col>
                                    <el-col :span="4">
                                        <img src="../assets/images/manet_6.jpg" alt="">
                                    </el-col>
                                </el-row>
                                <el-row type="flex" v-if="d.name == '载波聚合' && index == 5" class="ManetIcon" justify="space-between">
                                    <el-col :span="24">
                                        <img src="../assets/images/zbjh.jpg" alt="">
                                    </el-col>
                                </el-row>
                                <el-row type="flex" v-if="d.name == '波束成形' && index == 2" class="ManetIcon" justify="space-between">
                                    <el-col :span="24">
                                        <img src="../assets/images/bscx.jpg" alt="">
                                    </el-col>
                                </el-row>
                                <el-row type="flex" v-if="d.name == '智能选频' && index == 2" class="ManetIcon" justify="space-between">
                                    <el-col :span="24">
                                        <img src="../assets/images/znxp.gif" alt="" style="width: 100%;">
                                    </el-col>
                                </el-row>
                            </p>
                        </div>
                    </el-col>
                </el-row>
            </div>

        </el-main>
        <el-footer class="footer">
            <hq-footer></hq-footer>
        </el-footer>
    </div>
</template>

<script>
import Nav from "./Nav";
import Footer from "./Footer";

export default {
        name: "ProductDetail",
        data () {
            return {
                type:"",
                id:"",
                data:require("../assets/JSON/ManetContData.json"),
                cur:"MANET",
            }
        },
        methods: {
            liSwitch(e){
                this.cur = e;
            },
            handleScroll(){
                let sTop = document.documentElement.scrollTop;
                let d = this.data.listData;
                for (let i = 0; i < d.length; i++ ){
                    if (i < (d.length - 1)){
                        let top1 = (document.getElementById(d[i].name).offsetTop) - 120;
                        let top2 = (document.getElementById(d[i+1].name).offsetTop) - 120;
                        if (sTop >= top1 && sTop < top2){
                            this.liSwitch(d[i].name);
                            break;
                        }
                    }else{
                        this.liSwitch(d[d.length-1].name);
                    }
                }

                if ( sTop >= 200 ){
                    document.getElementById('navMenu').style.marginTop = '-170px';
                } else {
                    document.getElementById('navMenu').style.marginTop = '0px';
                }
            }
        },
        mounted() {
            this.type = this.$route.params.type;
            this.id = this.$route.params.id;
            this.liSwitch(this.$route.params.id);
            document.documentElement.scrollTop = document.getElementById(this.$route.params.id).offsetTop;

            window.addEventListener('scroll',this.handleScroll,true);
        },
        beforeDestroy() {
            window.removeEventListener('scroll',this.handleScroll,true);
        },
        components : {
            "hq-nav":Nav,
            "hq-footer":Footer,
        }
    }
</script>

<style scoped>
    .navbg{
        background: url("../assets/images/bg_2.jpg") no-repeat top center;
        background-size: 100% 100%;
    }
    .mainBox{
        background: #000000;
        padding: 5rem 0;
    }
    .navBox{
        box-sizing: border-box;
        padding-left: 2rem;
    }
    .navMenu{
        height: auto;
        border-left: 1px solid #414141;
        padding: 0;
        box-sizing: border-box;
        position: fixed;
        margin-top: 0rem;
    }
    .navMenu li{
        width: 100%;
        height: 3rem;
        line-height: 3rem;
        list-style: none;
        text-align: left;
        padding-left: 4rem;
        margin: 1rem 0 0 -1.5rem;
    }
    .navMenu li a{
        color: #414141;
        font-size: 1.125rem;
        text-decoration: none;
        font-family: AlibabaPuhuiTiR;
    }

    .navMenu li:hover a{
        font-family: AlibabaPuHuiTi-Bold;
        font-size: 1.75rem;
        color: #ffffff;
    }
    .navMenu li:hover{
        height: 3rem;
        line-height: 3rem;
    }
    .navBox li.clickLi{
        background: url("../assets/images/IconBlack.jpg") no-repeat left center;
        background-size: 3rem 3rem;
        height: 3rem;
        line-height: 3rem;
        margin-bottom: 1rem;
    }
    .navBox li.clickLi a{
        font-family: AlibabaPuHuiTi-Bold;
        font-size: 1.75rem;
        color: #ffffff;
    }
    .indexBt{
        background: #000000;
        color: #ffffff;
        text-align: left;
        margin: 0;
        box-sizing: border-box;
        padding-left: 2rem;
        font-size: 2rem;
        padding-top: 2rem;
        font-family: AlibabaPuHuiTi-Heavy;
    }

    .textCont{
        box-sizing: border-box;
        text-align: left;
    }
    .manet{
        width: 100%;
        height: auto;
        overflow: hidden;
    }
    .manet h1{
        font-size: 2rem;
        font-family: AlibabaPuHuiTi-Light;
        color: #ffffff;
        font-weight: normal;
    }
    .manet h1 span{
        font-family: AlibabaPuHuiTi-Heavy;
        font-size: 4.35rem;
    }
    .manet .text{
        font-family: AlibabaPuhuiTiR;
        font-size: 1.5rem;
        color: #ffffff;
        line-height: 2.75rem;
        margin: 3rem 0;
    }
    .ManetIcon,.COFDMIcon{
        margin-top: 3rem;
    }
    .ManetIcon .el-col-4{
        text-align: center;
    }

    .textMainMag .text:nth-child(4),
    .textMainMag .text:nth-child(5),
    .textMainMag .text:nth-child(6),
    .textMainMag .text:nth-child(7){
        margin: 1rem 0;
    }
</style>
